/**
 * @desc 数据储存仓库 - 取数集合
 * @author cwl
 */

 const getters = {
    /** 热线电话 */
    hotLine: (state) => state.hotLine,
  };
  
  export default getters;


// WEBPACK FOOTER //
// ./src/store/getters.js